
import {pricingMatrixIndexOfReference, pmtFunction} from './constants';

export default {
    name: 'LOAN INFO',
    hasNamesColumn: true,
    headerRow: [],
    rows: {
        'req-equity': {
            name: 'Down Payment',
            valueCells: [{
                unit: '%',
                type: 'number',
                editable: true,
                value: 30,
            }, {
                unit: '$',
                type: 'number',
                editable: false,
                tooltip: '= value * req_equity_percentage',
                getComputedValue(tables) {
                    const priceValue = tables['pricing-matrix'].rows['value'].valueCells[pricingMatrixIndexOfReference].getComputedValue(tables).internalValue;
                    const reqEquityPercentage = tables['pricing-matrix-annex'].rows['req-equity'].valueCells[0].value;
                    const value = priceValue * reqEquityPercentage / 100;
                    const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                    return {internalValue: value, displayValue: displayValue}
                }
            }]
        },
        'loan-amt': {
            name: 'Loan Amount',
            valueCells: [null, {
                unit: '$',
                type: 'number',
                editable: false,
                tooltip: '= value - req_equity',
                getComputedValue(tables) {
                    const priceValue = tables['pricing-matrix'].rows['value'].valueCells[pricingMatrixIndexOfReference].getComputedValue(tables).internalValue;
                    const reqEquity = tables['pricing-matrix-annex'].rows['req-equity'].valueCells[1].getComputedValue(tables).internalValue;
                    const value = priceValue - reqEquity;
                    const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                    return {internalValue: value, displayValue: displayValue}
                }
            }]
        },
        'total': {
            name: 'Total',
            valueCells: [null, {
                unit: '$',
                type: 'number',
                styleClasses: 'border-top bold',
                editable: false,
                tooltip: '= req_equity + loan_amt',
                getComputedValue(tables) {
                    const reqEquity = tables['pricing-matrix-annex'].rows['req-equity'].valueCells[1].getComputedValue(tables).internalValue;
                    const loanAmt = tables['pricing-matrix-annex'].rows['loan-amt'].valueCells[1].getComputedValue(tables).internalValue;
                    const value = reqEquity + loanAmt;
                    const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                    return {internalValue: value, displayValue: displayValue}
                }
            }]
        },
        'empty-row': {
            name: '',
            valueCells: [null, null]
        },
        'interest-rate': {
            name: 'Interest Rate',
            valueCells: [null, {
                unit: '%',
                type: 'number',
                editable: true,
                value: 4.25
            }]
        },
        'amortization': {
            name: 'Amortization',
            valueCells: [null, {
                unit: '',
                type: 'number',
                editable: true,
                value: 25
            }]
        },
        'annual-loan-payment': {
            name: 'Annual Loan Payment',
            valueCells: [null, {
                unit: '$',
                type: 'number',
                editable: false,
                tooltip: '= -PMT(interest_rate/12, amortization*12, loan_amt) * 12',
                getComputedValue(tables) {
                    const loanAmt = tables['pricing-matrix-annex'].rows['loan-amt'].valueCells[1].getComputedValue(tables).internalValue;
                    const interestRate = tables['pricing-matrix-annex'].rows['interest-rate'].valueCells[1].value;
                    const amortization = tables['pricing-matrix-annex'].rows['amortization'].valueCells[1].value;
                    const value = parseInt(-pmtFunction(interestRate / 100 / 12, amortization * 12, loanAmt) * 12);
                    const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                    return {internalValue: value, displayValue: displayValue}
                }
            }]
        },
        'cash-flow': {
            name: 'Cash Flow',
            valueCells: [null, {
                unit: '$',
                type: 'number',
                editable: false,
                tooltip: '= net_operating_income - annual_loan_payment',
                getComputedValue(tables) {
                    const netOperatingIncome = tables['offering-summary'].rows['net-operating-income'].getComputedValue(tables).internalValue;
                    const annualLoanPayment = tables['pricing-matrix-annex'].rows['annual-loan-payment'].valueCells[1].getComputedValue(tables).internalValue;
                    const value = parseInt(netOperatingIncome - annualLoanPayment);
                    const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                    return {internalValue: value, displayValue: displayValue};
                }
            }]
        },
        'dscr': {
            name: 'DSCR',
            valueCells: [null, {
                unit: '$',
                type: 'number',
                editable: false,
                tooltip: '= net_operating_income / annual_loan_payment',
                getComputedValue(tables) {
                    const netOperatingIncome = tables['offering-summary'].rows['net-operating-income'].getComputedValue(tables).internalValue;
                    const annualLoanPayment = tables['pricing-matrix-annex'].rows['annual-loan-payment'].valueCells[1].getComputedValue(tables).internalValue;
                    const value = parseFloat(netOperatingIncome / annualLoanPayment).toFixed(2);
                    const displayValue = !value || isNaN(value) ? '-' : value.toLocaleString();
                    return {internalValue: value, displayValue: displayValue}
                }
            }]
        },
    }
};